import React from 'react';
import { stats } from '../mock';
import { Reveal } from '../components/Reveal';

const values = [
  { title: 'Independent', text: 'We answer to our readers, not to any single interest in the energy value chain.' },
  { title: 'Rigorous', text: 'Data first. We separate the signal of the transition from the noise of the news cycle.' },
  { title: 'Global', text: 'Bureaus across four regions give us a view of energy as a genuinely global story.' },
  { title: 'Convening', text: 'We do not just report the conversation — we host it, on and off the record.' },
];

export default function About() {
  return (
    <div className="pt-32 md:pt-40 pb-24">
      <section className="section-pad">
        <div className="max-w-[1500px] mx-auto">
          <Reveal>
            <p className="eyebrow text-[#D01919] mb-4">About Enersider</p>
            <h1 className="font-display text-5xl md:text-8xl leading-[0.95] max-w-5xl">
              We exist to make the energy transition legible.
            </h1>
            <p className="text-[#666666] text-xl mt-8 max-w-2xl leading-relaxed">
              Enersider is an independent media platform covering the forces reshaping how the world makes and moves power. Through a monthly edition, sharp daily reporting and high-level dialogues, we help leaders see clearly in a sector defined by complexity.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="section-pad py-20 mt-10 bg-[#111111] text-[#ffffff] rounded-none">
        <div className="max-w-[1500px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-10">
          {stats.map((s, i) => (
            <Reveal key={i} delay={i * 80}>
              <div className="border-l border-white/20 pl-6">
                <p className="font-display text-5xl md:text-6xl text-[#D01919]">{s.value}</p>
                <p className="text-white/70 mt-2 text-sm">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="section-pad py-24">
        <div className="max-w-[1500px] mx-auto">
          <h2 className="font-display text-4xl md:text-5xl mb-12">What we stand for</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((v, i) => (
              <Reveal key={v.title} delay={i * 70}>
                <div className="border-t-2 border-[#111111] pt-5">
                  <h3 className="font-display text-2xl">{v.title}</h3>
                  <p className="text-[#666666] mt-3">{v.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
